import { Metamodel } from 'app/model/base/model';
import { FormatTypeCopySource } from './format-type.copysource';
import { AvroDataset } from 'shell-models-lib';

@Metamodel.model({
    name: 'AvroSource',
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(AvroDataset)]}
})
export class AvroCopySource extends FormatTypeCopySource {
}
